var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoForQRcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1756 22.5812L16.3613 0.99223C16.4827 0.369209 16.9932 -0.0540378 17.5021 0.0458488C17.9385 0.130498 18.2317 0.572368 18.2317 1.08873C18.2317 1.17507 18.2233 1.2648 18.2065 1.35453L14.0208 22.9435C13.8995 23.5666 13.3889 23.9898 12.88 23.8899C12.4436 23.8053 12.1504 23.3634 12.1504 22.847C12.1504 22.7607 12.1588 22.671 12.1756 22.5812Z",
    fill: "url(#paint0_linear_733_42206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0968 4.42988C14.0041 4.91069 13.5845 5.25775 13.0976 5.25775H8.69115L8.67264 5.25944L2.86593 11.9654L8.68276 18.6832L8.69115 18.6747H10.0999C10.7402 18.6747 11.2221 19.2622 11.0991 19.8937C11.0064 20.3745 10.5869 20.7215 10.0999 20.7215H8.69115C8.14519 20.7215 7.6144 20.5048 7.23528 20.1256L1.32748 13.3062C0.976986 12.9405 0.783203 12.4665 0.783203 11.9654C0.783203 11.4643 0.975301 10.9902 1.32748 10.6262L7.18474 3.86106L7.23697 3.80519C7.61777 3.42764 8.14856 3.21094 8.69284 3.21094H13.0992C13.7379 3.21094 14.2198 3.79842 14.0968 4.42988Z",
    fill: "url(#paint1_linear_733_42206)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1435 3.80689L25.0459 6.00268H27.8566C28.234 6.00268 28.5407 6.31081 28.5407 6.69005V7.49928C28.5407 7.87853 28.234 8.18666 27.8566 8.18666H26.9365L29.0513 10.6279C29.4017 10.9936 29.5955 11.4677 29.5955 11.9671C29.5955 12.4682 29.4034 12.9422 29.0513 13.3062L23.194 20.0697L23.1418 20.1256C22.761 20.5048 22.2302 20.7215 21.6842 20.7215H17.2795C16.6391 20.7215 16.1572 20.1341 16.2785 19.5026C16.3712 19.0218 16.7908 18.6747 17.2795 18.6747L21.7044 18.673L27.5111 11.9671L21.696 5.24932L21.6859 5.25775H20.2772C19.6369 5.25775 19.1549 4.67029 19.278 4.03882C19.3706 3.558 19.7902 3.21094 20.2772 3.21094H21.6859C22.2319 3.21094 22.7627 3.42934 23.1435 3.80689Z",
    fill: "url(#paint2_linear_733_42206)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4281 9.98106L22.8671 11.6419C22.953 11.7316 23.0002 11.8467 23.0002 11.9686C23.0002 12.0905 22.953 12.2056 22.8671 12.2954L21.4399 13.9426L21.4281 13.9562C21.3354 14.0476 21.2057 14.1018 21.0725 14.1018H20.0884C19.8525 14.1018 19.6621 13.9105 19.6621 13.6735V10.2638C19.6621 10.0268 19.8525 9.83545 20.0884 9.83545H21.0725C21.2057 9.83545 21.3354 9.88793 21.4281 9.98106Z",
    fill: "url(#paint3_linear_733_42206)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69322 13.946L7.94581 13.1638C7.87335 13.1317 7.82617 13.0589 7.82617 12.9793V10.9562C7.82617 10.8766 7.87335 10.8038 7.94581 10.7716L9.69322 9.98945C9.80443 9.94036 9.92913 9.94036 10.0403 9.98945L11.7877 10.7716C11.8602 10.8038 11.9074 10.8766 11.9074 10.9562V12.9793C11.9074 13.0589 11.8602 13.1317 11.7877 13.1638L10.0403 13.946C9.92913 13.9968 9.80274 13.9968 9.69322 13.946Z",
    fill: "url(#paint4_linear_733_42206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_42206",
    x1: -5.68206,
    y1: 24.4016,
    x2: 31.5716,
    y2: 2.41735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.29095e-7,
    stopColor: "#6317F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_42206",
    x1: -7.22902,
    y1: 21.782,
    x2: 30.0247,
    y2: -0.20232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.29095e-7,
    stopColor: "#6317F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_42206",
    x1: -4.14018,
    y1: 27.0197,
    x2: 33.1136,
    y2: 5.03545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.29095e-7,
    stopColor: "#6317F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_733_42206",
    x1: -4.27999,
    y1: 26.7843,
    x2: 32.9737,
    y2: 4.80011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.29095e-7,
    stopColor: "#6317F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_733_42206",
    x1: -7.06984,
    y1: 22.0569,
    x2: 30.1839,
    y2: 0.0726933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.29095e-7,
    stopColor: "#6317F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForQRcode);
export default __webpack_public_path__ + "static/media/logoForQRcode.648209c33185663cb39b5adcb9a416aa.svg";
export { ForwardRef as ReactComponent };